module.exports = __webpack_public_path__ + "img/cosplay.05ef4699.jpeg";